import { Component, HostListener, ViewChild } from '@angular/core';
import { SiaOperator, SiaTranslatePipe } from '@sia/shared';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import {
  DxiColumnModule,
  DxoColumnChooserModule,
  DxoEditingModule,
  DxoFilterRowModule,
  DxoGroupPanelModule,
  DxoGroupingModule,
  DxoHeaderFilterModule,
  DxoLoadPanelModule,
  DxoLookupModule,
  DxoRemoteOperationsModule,
  DxoScrollingModule,
  DxoSearchPanelModule,
  DxoSelectionModule,
  DxoSortingModule,
} from 'devextreme-angular/ui/nested';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';

@Component({
  selector: 'sia-grid-config-style',
  templateUrl: './sia-grid-config-style.component.html',
  styleUrls: ['./sia-grid-config-style.component.scss'],
  providers: [
    {
      provide: SiaGridConfigTab,
      useExisting: SiaGridConfigStyleComponent,
    },
  ],
  standalone: true,
  imports: [
    DxDataGridModule,
    DxiColumnModule,
    DxoLookupModule,
    DxoEditingModule,
    DxoSelectionModule,
    DxoRemoteOperationsModule,
    DxoSortingModule,
    DxoColumnChooserModule,
    DxoLoadPanelModule,
    DxoHeaderFilterModule,
    DxoFilterRowModule,
    DxoSearchPanelModule,
    DxoGroupPanelModule,
    DxoGroupingModule,
    DxoScrollingModule,
    SiaTranslatePipe,
  ],
})
export class SiaGridConfigStyleComponent extends SiaGridConfigTab {
  @ViewChild(DxDataGridComponent, { static: false })
  childDataGrid: DxDataGridComponent | undefined;
  gridConfFiltersTypes: SiaOperator[] = [];

  @HostListener('window:unload')
  ngOnDestroy() {
    this.destroyDxComponent(this.childDataGrid, 'gridStyle');
    super.ngOnDestroy();
  }

  operators: SiaOperator[] = [
    { id: '', name: 'Nessuno' },
    { id: '<', name: '<' },
    { id: '<=', name: '<=' },
    { id: '>', name: '>' },
    { id: '>=', name: '>=' },
    { id: '==', name: '==' },
    { id: '!=', name: '<>' },
    { id: 'notcontains', name: 'Non contiene' },
    { id: 'contains', name: 'Contiene' },
    { id: 'startswith', name: 'Inizia per' },
    { id: 'anyof', name: 'IN' },
    { id: 'endswith', name: 'Termina con' },
  ];

  onConfigStyleRowUpdating(e: any) {}
}
